module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAPBJREFUOE+lk80NwjAMhZ/TbMAZLrAAMEZSlSuwBgdGqARr8HOkatYABoAbV9igbZCrFoWoIH5yS/Q+28+xCd4Jw3BQFMUYwAhAF8AZQCKE2KRpenDlVF+01h1rbQyAwcZDROsgCOZJklxYUMIVyFFbr0Dn/Sal7HOAElZKrf2MxpiHXmv9FJMrMMZMqfK49zO+g1krhBiSUmoBYPYtDGDJ8AlAj2E32yvvjoUTw0XduC9h+3fmnzwT0eK/bldDsrLWTtwmffTPDERR1M6y7PjhhF2llIPHhNUB8jyP/QqeFqFptl1B01YR0Y6Itv5W3QEk4npx5DQ6hwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/images/add_icon.png
// module id = 1309
// module chunks = 0